import { render, staticRenderFns } from "./SuppliesCate.vue?vue&type=template&id=769f0902&scoped=true"
import script from "./SuppliesCate.vue?vue&type=script&lang=js"
export * from "./SuppliesCate.vue?vue&type=script&lang=js"
import style0 from "./SuppliesCate.vue?vue&type=style&index=0&id=769f0902&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769f0902",
  null
  
)

export default component.exports